import { validateEmail, validatePhone } from "shared/pages/DesignFabric/support/validate";
import { ApplicationFormActions } from "shared/reducers/ApplicationFormSlice";

const PHONE_REG = /^\+?[87]([- ]?)\d{3}\1\d{3}\1\d{2}\1\d{2}$/;

const validate = (values: any, props: any) => {
    const { dispatch } = props;
    const requiredFields: string[] = [];
    const errors: Record<string,string> = {};

    props?.data?.fields?.forEach(({ name, required }) => {
        if (required) {
            requiredFields.push(name)
        }
    })

    const hasRequired = requiredFields.every(
        (field) => Object.keys(values)?.includes(field))

    if (!hasRequired) {
        //@ts-ignore
        errors.required = 'Заполните обязательные поля';
    }

    if (!values?.projectFilesIds?.length || values?.projectFilesIds?.length < 2) {
        errors.projectFilesIds = 'Не хватает изображений (необходимо 2)';
    }
    if (values?.projectFilesIds?.length > 2 ) {
        errors.projectFilesIds = 'Слишком много изображений (необходимо 2)';
    }
    if (values.participantEmail && validateEmail(values.participantEmail)) {
        errors.participantEmail = 'Некорректный email';
    }
    if (values.participantPhone && !values.participantPhone.match(PHONE_REG)) {
        errors.participantPhone = 'Некорректный формат телефона';
    }
    const hasAgreementField = props?.data?.fields?.some((field: any) => field.name === 'agreement');
    if (hasAgreementField && values.agreement !== true) {
        errors.agreement = 'Необходимо принять пользовательское соглашение';
    }

    dispatch(ApplicationFormActions.setErrors(Object.values(errors)))

    return errors;
}

export default validate;import { validateEmail, validatePhone } from "shared/pages/DesignFabric/support/validate";
import { ApplicationFormActions } from "shared/reducers/ApplicationFormSlice";

const PHONE_REG = /^\+?[87]([- ]?)\d{3}\1\d{3}\1\d{2}\1\d{2}$/;

const validate = (values: any, props: any) => {
    const { dispatch } = props;
    const requiredFields: string[] = [];
    const errors: Record<string,string> = {};

    props?.data?.fields?.forEach(({ name, required }) => {
        if (required) {
            requiredFields.push(name)
        }
    })

    const hasRequired = requiredFields.every(
        (field) => Object.keys(values)?.includes(field))

    if (!hasRequired) {
        //@ts-ignore
        errors.required = 'Заполните обязательные поля';
    }

    if (!values?.projectFilesIds?.length || values?.projectFilesIds?.length < 2) {
        errors.projectFilesIds = 'Не хватает изображений (необходимо 2)';
    }
    if (values?.projectFilesIds?.length > 2 ) {
        errors.projectFilesIds = 'Слишком много изображений (необходимо 2)';
    }
    if (values.participantEmail && validateEmail(values.participantEmail)) {
        errors.participantEmail = 'Некорректный email';
    }
    if (values.participantPhone && !values.participantPhone.match(PHONE_REG)) {
        errors.participantPhone = 'Некорректный формат телефона';
    }
    const hasAgreementField = props?.data?.fields?.some((field: any) => field.name === 'agreement');
    if (hasAgreementField && values.agreement !== true) {
        errors.agreement = 'Необходимо принять пользовательское соглашение';
    }

    dispatch(ApplicationFormActions.setErrors(Object.values(errors)))

    return errors;
}

export default validate;